import { useCreateDataTableOptions } from "@/components/data-table/hooks/useCreateDataTableOptions";
import { useDynamicQueryParams } from "@/hooks/useDynamicQueryParams";
import { Filters, mergeFilters } from "@/lib/filters";
import { FetchListRequest } from "@/services/api";
import { StoreService } from "@/modules/store/service/store";
import { ReadStore } from "@/types/store";
import { keepPreviousData, useInfiniteQuery } from "@tanstack/react-query";
import { useMemo } from "react";

export const useStoresQuery = ({
  enabled = true,
  filters: filtersFromProps,
  name = "stores",
}: {
  enabled?: boolean;
  filters?: Filters<ReadStore>;
  name?: string;
} = {}) => {
  const options = useCreateDataTableOptions<ReadStore>(name);
  const fetchList = (fetchParams: FetchListRequest<ReadStore>) => {
    return StoreService.getList(fetchParams);
  };

  const filters = useMemo(
    () => mergeFilters(options.filters, filtersFromProps),
    [filtersFromProps, options.filters],
  );

  const queryKey = useDynamicQueryParams(name, options);
  const query = useInfiniteQuery({
    queryKey,
    queryFn: ({ pageParam }) =>
      fetchList({
        lastItem: pageParam,
        filters,
        sorting: options.sorting[0],
      }),
    initialPageParam: undefined,
    getNextPageParam: ({ last_item }) => last_item,
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
    enabled,
  });

  return {
    query,
    options,
  };
};
